import { render, staticRenderFns } from "./Ctrl.vue?vue&type=template&id=53ae801a&"
import script from "./Ctrl.vue?vue&type=script&lang=js&"
export * from "./Ctrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports